import {
  CloseButton,
  Flex,
  Group,
  rem,
  Image,
  Box,
  ThemeIcon,
} from "@mantine/core";
import {
  Spotlight as MantineSpotlight,
  SpotlightActionData,
  SpotlightActionGroupData,
} from "@mantine/spotlight";
import SpotlightAction from "./components/SpotlightAction/SpotlightAction";
import {
  IconFilePlus,
  IconReceipt2,
  IconSearch,
  IconUserEdit,
  IconUserPlus,
  IconUserX,
} from "@tabler/icons-react";
import NextImage from "next/image";
("next/image");
import { useState } from "react";

import QuickBooksIcon from "../../_media/quickbooks.svg";
import useDeviceType from "@/app/_hooks/useDeviceType";

const actions: {
  group: string;
  actions: (SpotlightActionData & {
    videoUrl: string;
    videoTitle: string;
  })[];
}[] = [
  {
    group: "Clients",
    actions: [
      {
        id: "How to Add a Client",
        label: "How to Add a Client",
        description:
          "Learn everything about adding a client and getting them ready for jobs",
        videoUrl:
          "https://www.youtube.com/embed/8G2gnife39g?vq=hd2160&quality=high",
        videoTitle: "How to Add a Client",
        leftSection: (
          <ThemeIcon color="green">
            <IconUserPlus style={{ width: "70%", height: "70%" }} />
          </ThemeIcon>
        ),
      },
      {
        id: "How to Update a Client",
        label: "How to Update a Client",
        description: "See how to update a client and how client history works",
        videoUrl:
          "https://www.youtube.com/embed/MuBbunQLNOI?vq=hd2160&quality=high",
        videoTitle: "How to Update a Client",
        leftSection: (
          <ThemeIcon color="orange">
            <IconUserEdit style={{ width: "70%", height: "70%" }} />
          </ThemeIcon>
        ),
      },
      {
        id: "How to Delete a Client",
        label: "How to Delete a Client",
        description: "See how to fully delete a client and their jobs",
        videoUrl:
          "https://www.youtube.com/embed/NM1nxke1Y9A?vq=hd2160&quality=high",
        videoTitle: "How to Delete a Client",
        leftSection: (
          <ThemeIcon color="red">
            <IconUserX style={{ width: "70%", height: "70%" }} />
          </ThemeIcon>
        ),
      },
    ],
  },

  {
    group: "Jobs",
    actions: [
      {
        id: "How to Add a Job",
        label: "How to Add a Job",
        description: "Learn everything about adding a job",
        videoUrl:
          "https://www.youtube.com/embed/lV9tXc6mqK0?vq=hd2160&quality=high",
        videoTitle: "How to Add a Job",
        leftSection: (
          <ThemeIcon color="green">
            <IconFilePlus style={{ width: "70%", height: "70%" }} />
          </ThemeIcon>
        ),
      },
    ],
  },
  {
    group: "Price List",
    actions: [
      {
        id: "How to use the Price List",
        label: "How to use the Price List",
        description:
          "Learn about adding PriceList items and speeding up your job creation",
        videoUrl:
          "https://www.youtube.com/embed/LBaCuwMDYfo?vq=hd2160&quality=high",
        videoTitle:
          "Learn about the Price List and start speeding up your job creation",
        leftSection: (
          <ThemeIcon color="blue">
            <IconReceipt2 style={{ width: "70%", height: "70%" }} />
          </ThemeIcon>
        ),
      },
    ],
  },

  {
    group: "QuickBooks",
    actions: [
      {
        id: "How to set up Quickbooks",
        label: "How to set up Quickbooks",
        description:
          "Learn how to set up the Quickbooks integration and begin syncing your jobs and clients.",
        videoUrl:
          "https://www.youtube.com/embed/2zrPasMBx9I?vq=hd2160&quality=high",
        videoTitle: "How to set up Quickbooks",
        leftSection: (
          <Box w={24}>
            <Image
              component={NextImage}
              src={QuickBooksIcon}
              width={24}
              height={24}
              alt="QuickBooks"
            />
          </Box>
        ),
      },
    ],
  },
];

const Spotlight = () => {
  const [query, setQuery] = useState("");
  const { isMobile } = useDeviceType();
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const filteredActions = actions
    .map((group) => {
      if ("group" in group) {
        return {
          ...group,
          actions: group.actions.filter((action) =>
            action.label.toLowerCase().includes(query.toLowerCase().trim())
          ),
        };
      }
      return group;
    })
    .filter((group) => ("group" in group ? group.actions.length > 0 : true));

  return (
    <MantineSpotlight.Root
      query={query}
      onQueryChange={setQuery}
      closeOnActionTrigger={false}
      size={isMobile ? "xl" : "80%"}
      styles={{ inner: { left: 0 } }}
      yOffset={"5dvh"}
    >
      <Flex direction="column">
        <Group justify="space-between" px="sm">
          <MantineSpotlight.Search
            flex={1}
            placeholder="Search..."
            leftSection={<IconSearch />}
          />
          <CloseButton onClick={() => MantineSpotlight.close()} />
        </Group>
        <MantineSpotlight.ActionsList mah={`calc(100dvh - 15dvh)`}>
          {filteredActions.length > 0 ? (
            filteredActions.map((group) =>
              "group" in group ? (
                <MantineSpotlight.ActionsGroup
                  key={group.group}
                  label={group.group}
                >
                  {group.actions.map((item) => (
                    <SpotlightAction
                      key={item.id}
                      item={item}
                      query={query}
                      expandedId={expandedId}
                      setExpandedId={setExpandedId}
                    />
                  ))}
                </MantineSpotlight.ActionsGroup>
              ) : null
            )
          ) : (
            <MantineSpotlight.Empty>Nothing found...</MantineSpotlight.Empty>
          )}
        </MantineSpotlight.ActionsList>
      </Flex>
    </MantineSpotlight.Root>
  );
};

export default Spotlight;
